import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'UsersPage',
  //   description: 'description of UsersPage',
  //   url: '/users-page',
  // },
];

export default help;
